import type { ComponentPropsWithoutRef } from 'react'
import { styled } from '@mui/material/styles'

export const Banner = styled('section')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(2),
  boxSizing: 'border-box',
  width: '100%',
  borderRadius: 0,
  color: theme.palette.common.white,
  background: 'linear-gradient(270deg, #1B5426 0%, #277634 100%)',
  overflow: 'hidden'
}))

export const Content = styled('div')(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 532,
    margin: '0 auto'
  }
}))

interface IllustrationProps extends ComponentPropsWithoutRef<'img'> {
  isExpanded: boolean
}
export const Illustration = styled(
  // eslint-disable-next-line jsx-a11y/alt-text, @typescript-eslint/no-unused-vars
  ({ isExpanded, ...props }: IllustrationProps) => <img {...props} />
)(({ isExpanded }) => ({
  position: 'absolute',
  right: 0,
  top: isExpanded ? -15 : -70,
  width: isExpanded ? 155 : 160,
  pointerEvents: 'none',
  transition: 'top 0.3s ease, width 0.3s ease'
}))

export const Header = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12
})
